<!--
  - Copyright (c) 2023-2024. Haodong JU
  -->

<script>

import SaaSChildPageContainer from '@/views/SaaS/widget/SaaSChildPageContainer.vue'
import QrCodeDisplay from '@/views/SaaS/widget/QrCodeDisplay.vue'
import GlobalConfig from '@/model/global/GlobalSettings'
import { ProductCodes } from '@/model/dataLayer/api/SaaS/product'
import { getActiveProductCode } from '@/model/dataLayer/api/SaaS/user'

export default {
  name: 'GuideForDownloadApp',
  components: {
    QrCodeDisplay,
    SaaSChildPageContainer
  },
  data: function () {
    return {
      ownedRestaurant: false,
      loading: false
    }
  },
  computed: {
    downloadUrl () {
      return !this.ownedRestaurant ? 'http://aaden.online/123.apk' : 'https://app.aaden.io'
    }
  },
  async mounted () {
    this.ownedRestaurant = (await getActiveProductCode(GlobalConfig.DeviceId)).includes(ProductCodes.restaurant)
  },
  methods: {
    openDownloadUrl () {
      window.open(this.downloadUrl)
      location.reload()
    },
    async next () {
      location.reload()
    }
  }
}
</script>

<template>
  <saa-s-child-page-container>
    <template #title>
      <template v-if="ownedRestaurant">
        <div class="text-h3">
          {{ $t('GoToFrontendApplication') }}
        </div>
        <div class="text-body-2 text--secondary mt-8">
          {{ $t('AadenAppDlInfoText') }}
        </div>
      </template>
      <template v-else>
        <div class="text-h3">
          {{ $t('DownloadOrderApp') }}
        </div>
        <div class="text-body-2 text--secondary mt-8">
          {{ $t('PleaseScanQROrEnterURL') }}
        </div>
      </template>
    </template>
    <div
      class="mt-8"
      style="display: grid;grid-template-columns: 1fr;grid-gap: 12px"
    >
      <div
        class="d-flex justify-center"
        style="width: 100%;"
      >
        <qr-code-display
          :data="downloadUrl"
          :size="'128'"
        />
      </div>
      <div
        class="pa-4 d-flex flex-column align-start"
        style="height: 100%"
      >
        <template v-if="!ownedRestaurant">
          <div class="text-body-1">
            <span class="font-weight-black">Aaden </span> Compose AnteLope
          </div>
          <div class="text-body-2 mt-2">
            {{ $t('OrderAppHint') }}
          </div>
          <v-spacer />
          <div class="d-flex align-center justify-center mt-4">
            <v-btn
              class="mr-2"
              color="amber black--text lighten-5"
              elevation="0"
              small
              @click="openDownloadUrl"
            >
              {{ $t('AndroidVersion') }}
            </v-btn>
            <v-btn
              color="amber black--text lighten-5"
              disabled
              elevation="0"
              small
              @click="openDownloadUrl"
            >
              {{ $t('IosVersion') }}
            </v-btn>
          </div>
        </template>
        <template v-else>
          <div class="text-body-1">
            <span class="font-weight-black">Aaden </span> POS
          </div>
          <div class="text-body-2 mt-2">
            {{ $t('OrderAppHint') }}
          </div>
          <v-spacer />
          <div class="d-flex mt-4">
            <v-btn
              class="mr-2"
              color="amber black--text lighten-5"
              elevation="0"
              small
              @click="openDownloadUrl"
            >
              {{ $t('Open') }}
            </v-btn>
          </div>
        </template>
      </div>
    </div>
    <div>
      <v-btn
        class="primary"
        elevation="0"
        small
        width="100%"
        @click="next"
      >
        Admin
      </v-btn>
    </div>
  </saa-s-child-page-container>
</template>

<style scoped>

</style>
